<template class="">
			<!-- <div class="form-group col-md-2" style="margin:0px">
				<div class="form-row">
					<h3 class="form-group" style="margin:0px;">Guardrails</h3>
					<button @click="openAutomationPopup" class="btn btn-primary add-new-campaign" style = "margin-top:3px !important">
						<i class="fa fa-plus"></i>
					</button>
				</div>
			</div> -->
	<div class="">

	
	<CommonHeader class="main_head_block ">
		<template v-slot:header class="">

			<span class="module_heading" style="width:auto;"> {{owner =='Me' ? 'My' :'All'}} Guardrails</span>
			<div class="add_icon_container" @click="openGuardrail">
          		<i class="fa fa-plus icon_add"></i>
      		</div>
			

			<!-- <div class="sel_fil_wrap one">
				<multiselect
					v-model="selectedOwner"
					:options="ownerList"
					:show-no-results="true"
					ref="multiselect"
					label="type"
					:track-by="id"
					open-direction="bottom"
					:taggable="false"
					placeholder="Owner"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					deselectLabel = ""
					@select = "selectOwner"
					@remove = "resetOwner()"
					@open="toggle()"
					/>
			</div> -->
			<div class="sel_fil_wrap one bold_arrow">
				<multiselect
					v-model="target"
					:options="targetList"
					ref="multiselect"
					open-direction="bottom"
					:taggable="false"
					placeholder="Target"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					deselectLabel = ""
					@select = "selectTarget"
					@remove = "resetTarget()"
					@open="toggle()"
					/>
			</div>
			<div class="sel_fil_wrap two" v-if="target && target!='All' && target!='Keyword'">
				<multiselect
					v-model="subTarget"
					:options="subTargetList"
					ref="multiselect"
					open-direction="bottom"
					:taggable="false"
					placeholder="Type"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					deselectLabel = ""
					label="label"
					@open="toggle()"
					track-by='label'
					:hideSelected='true'
					/>
			</div>
			<div class="sel_fil_wrap two" v-if="subTarget && subTarget.id">
				<multiselect
					v-if="(subTarget.id!='Enter Asin' && !fetchingDropDownValue)"
					v-model="subTargetValue"
					:options="subTargetValueList"
					ref="multiselect"
					open-direction="bottom"
					:taggable="false"
					:placeholder="subTarget&&subTarget.name"
					class="form-control multi-dropdown select_filter"
					selectLabel = ""
					deselectLabel = ""
					label="name"
					@open="toggle()"
					:track-by="getTrackBy()"
					@select = "selectSubTargetValue"
					@remove = "resetSubTargetValue()"
					@search-change = "dynamicSubTargetList"
					:loading='dynamicFetching'
					:preserveSearch='true'
					/>
					<input v-model="subTargetValue" class="inp_header" type="search"  @keyup.enter="selectSubTargetValueAsin()" v-if="subTarget.id=='Enter Asin'" placeholder="Enter asin" style="outline: none; padding: 3px 3px 5px 10px"/>
					<div v-else-if="fetchingDropDownValue" class="spinner-border" style="margin:auto;display:block;"></div>
			</div>
		
		</template>
	</CommonHeader>
	<AddEditAutomation
			v-if="callModal"
			@toggleModal="toggleModal"
			automationId="null"
		/>
		</div>
</template>
<script>
	import AddEditAutomation from "@/components/Automation2/AddEditAutomation2.vue";
	import Multiselect from "vue-multiselect";
	import CampaignFormDropDown from "@/components/add-campaign/CampaignFormDropDownNew";
	import AutomationFilter from "@/components/Automation2/AutomationFilters"
	import CommonHeader from "@/components/CommonHeader.vue"
	export default {
		name: "automation2Header",
		components: {
			Multiselect,
			AddEditAutomation,
			CampaignFormDropDown,
			AutomationFilter,
			CommonHeader
		},
		mounted() {
			//this.fetchAdvanceFilterList()
		},
		data() {
			return {
				callModal: false,
				true:true,
				false:false,
				showCampignGroupFilter:false,
				ownerList:[
					{
						type:"Me",
						id:"Me"
					},
					{
						type:"All",
						id:"All"
					}
				],
			 	selectedOwner:{
					type:"Me",
					id:"Me"
				},
				targetList:['All','Campaign','Campaign Group','Product'],
				dropDownLists:{
					vendorList:[],
					brandList:[],
					keywordList:[],
					campaignList:[],
					campaignGroupList:[],
					productList:[]
				},
				count : 0,
				renderComponent:true,
				selectScopeValues: [
					{ id: "Vendor", name: "Select Vendor", label: "Filter By vendor",type:'vendor'  },
					{ id: "Profile", name: "Select Brand Profile", label: "Filter By brand",type:'brand'},
					{ id: "CampaignGroup", name: "Select Campaign Group", label: "Filter By campaign group",type:'campaign_group'},
					{ id: "Campaign", name: "Select Campaign", label: "Filter By campaign",type:'campaign'},
					{ id: "Enter Asin", name: "Enter Asin", label: "Filter By asin",type:'asin'}
				],
				subTargetList:[],
				subTargetValueList:[],
				fetchingDropDownValue:false,
				dynamicFetching:false
		  };
		},
		computed: {
			subTargetValue:{
				set(val){
					 this.$store.state.automation.subTargetValue = val
					 this.$store.state.currentPageNumber = 1
					 if(this.subTarget && this.subTarget.id == 'Enter Asin' && !val){
						 this.$store.dispatch("automation/getAutomations");
					 }
				},
				get(){
					return this.$store.state.automation.subTargetValue
				}
			},
			subTarget:{
				set(val){
					this.$store.state.automation.subTarget = val
					this.subTargetValue = null
					this.fetchingDropDownValue = false
					this.subTargetValueList = []
					if(val){
						this.$store.dispatch("automation/getAutomations");
						this.initialiseSubTargetValuesList()
					}
				},
				get(){
					return this.$store.state.automation.subTarget
				}
			},
			target:{
				set(val){
					this.subTarget = null
					this.subTargetList = []
					if(val){
						this.initialiseSubTargetList()
					}
					//this.forceRerender()
				},
				get(){
					return this.$store.state.automation.target
				}
			},
			vendorsList: {
				set(val) {
					this.$store.commit("updateVendorList", val);
				},
				get() {
					return this.$store.state.vendorList;
				}
			},
			campaignGroupFilterList: {
				set(val) {
					this.$store.commit(
						"campaign/updateCampaignGroupFilterList",
						val
					);
				},
				get() {
					return this.$store.state.campaign.campaignGroupFilterList;
				}
			},
			selectedVendorFilter: {
				set(val) {
					if (val == "") {
						this.$store.state.selectedCampaignGroupFilter = "";
						this.showCampignGroupFilter = false;
					} else {
						this.showCampignGroupFilter = true;
					}
					this.$store.state.selectedVendorFilter = val;
					this.$store.commit("setSelectedVendorFilter", val);
				},
				get() {
					if (this.$store.state.selectedCampaignGroupFilter) {
						this.showCampignGroupFilter = true;
					}
					return this.$store.state.selectedVendorFilter;
				}
			},
			selectedCampaignGroupFilter: {
				set(val) {
					this.$store.state.selectedCampaignGroupFilter = val;
				},
				get() {
					return this.$store.state.selectedCampaignGroupFilter;
				}
			},
			owner: {
				set(val) {
					this.$store.state.automation.owner = val;
				},
				get() {
					return this.$store.state.automation.owner;
				}
			}
		},
		methods: {
			dynamicSubTargetList(query){
				if((this.subTarget.id=='Campaign'||this.subTarget.id=='CampaignGroup')&&query){
					this.dynamicFetching = true
					this.initialiseSubTargetValuesList(query)
				}
			},
			selectSubTargetValueAsin(){
				this.$store.state.automation.subTargetValue = this.subTargetValue
				this.$store.state.currentPageNumber = 1
				if(this.subTargetValue){
					this.$store.dispatch("automation/getAutomationsFiltered");
				}
				else{
					this.$store.dispatch("automation/getAutomations");
				}
			},
			selectSubTargetValue(val){
				this.$store.state.automation.subTargetValue = val
				this.$store.state.currentPageNumber = 1
				this.$store.dispatch("automation/getAutomationsFiltered");
				//this.$store.dispatch("automation/getAutomations");
			},
			resetSubTargetValue(){
				this.$store.state.automation.subTargetValue = null
				this.$store.state.currentPageNumber = 1
				//this.$store.dispatch("automation/getAutomationsFiltered");
				this.$store.dispatch("automation/getAutomations");
			},
			initialiseSubTargetValuesList(query){
				const vm = this
				this.subTargetValueList = []
				if(!query){
					this.fetchingDropDownValue = true
				}
				let storeUrl = ''
				let queryString = {
					"q": query||'',
					"resultsPerPage":null,
					"pageNumber":1,
					"sort":"",
					"doNotShowSpinner": true
				}
				switch (this.subTarget.id) {
					case 'Vendor':
						storeUrl = "getAllVendor"
						break;
					case 'Profile':
						storeUrl = "getAllBrandProfile";
						break;
					case 'CampaignGroup':
						storeUrl = "campaign/getCampaignGroupList";
						break;
					case 'Campaign':
						storeUrl = "campaign/getCampaignList";
						break;
					default:
						break;
				}

				if(this.subTarget && storeUrl && this.subTarget.id!='Enter Asin')
				{
					this.$store.dispatch(storeUrl, queryString).then((response) => {
						vm.fetchingDropDownValue = false
						vm.dynamicFetching = false
						if(vm.subTarget.id=='Campaign'){
							vm.subTargetValueList = response.data.filter(item=>item.ams_campaign_id)
						}
						else{
							vm.subTargetValueList = response;
						}

					});
				}
				if(this.subTarget && this.subTarget.id=='Enter Asin'){
					vm.fetchingDropDownValue = false
					vm.dynamicFetching = false
				}
			},
			initialiseSubTargetList(){
				
				if(this.target==="Campaign"){
					this.subTargetList=this.selectScopeValues.slice(0,4)
				}
				else if(this.target==="Keyword"){
						this.subTargetList=this.selectScopeValues.slice(0,4)
				}
				else if(this.target==="Brand Profile"){
						this.subTargetList=this.selectScopeValues.slice(0,3)
				}
				else if(this.target==="Campaign Group"){
					this.subTargetList=this.selectScopeValues.slice(0,3)
				}
				else if(this.target==="Product"){
					// this.subTargetList = this.selectScopeValues.slice(0,2)
					// let values = this.selectScopeValues.slice(4,5)
					this.subTargetList = this.selectScopeValues.slice(4,5)
				}
				this.subTargetList.unshift({ name: "Select All", label: "Select all"})
			},
			forceRerender () {
				this.renderComponent = false;
				this.$nextTick (() => {
				 this.renderComponent = true;
				});
			},
			fetchAdvanceFilterList(){
				const vm = this
				let queryString = {
					"q": '',
					"resultsPerPage":null,
					"pageNumber":1,
					"sort":"",
				}
				this.count = 0
				this.$store.dispatch('getAllVendor', queryString).then((searchData) => {
					vm.dropDownLists.vendorList = searchData;
					vm.count++
				});
				this.$store.dispatch('getAllBrandProfile', queryString).then((searchData) => {
					vm.dropDownLists.brandList = searchData;
					vm.count++
				});
				this.$store.dispatch('campaign/getCampaignList', queryString).then((searchData) => {
					vm.dropDownLists.campaignList = searchData.data;
					vm.count++
				});
				this.$store.dispatch('campaign/getCampaignGroupList', queryString).then((searchData) => {
					vm.dropDownLists.campaignGroupList = searchData;
					vm.count++
				});
				this.$store.dispatch('product/getAllProductsForScope', queryString).then((searchData) => {
					vm.dropDownLists.productList = searchData;
					vm.count++
				});
			},
			toggle(){
				this.$emit("toggleModal");
			},
			getAutomationList() {
				let vm = this;
				//Add a call to bring automation list based on selected vendor or/and campaignGroup from header filters
			},
			selectedHeaderValue(id, type) {
				if (type == "Select Campaign group") {
					this.selectedCampaignGroupFilter = id;
					this.getAutomationList();
				} else if (type == "Select Vendor") {
					this.selectedVendorFilter = id;
					this.getAutomationList();
				}
			},
			fetchDynamicList(search, type) {
				if (type == "Select Campaign group") {
					this.fetchDynamicCampGrpList(search);
				}
				if (type == "Select Vendor") {
					this.fetchDynamicVendorList(search);
				}
			},
			fetchDynamicCampGrpList(search) {
				const vm = this;
				var obj = {
					str: search,
					go_vendor_cd: this.selectedVendorFilter
						? this.selectedVendorFilter
						: ""
				};
				this.$store
					.dispatch("campaign/fetchDynamicCampGrpList", obj)
					.then(res => {
						vm.campaignGroupFilterList = res ? res : [];
					});
			},
			fetchDynamicVendorList(search) {
				const vm = this;
				var obj = {
					str: search
				};
				this.$store.dispatch("getAllVendor", obj).then(res => {
					vm.vendorsList = res ? res : [];
				});
			},
			toggleModal() {
				this.callModal = false;
			},
			openGuardrail(){
				this.$router.push({
					path: '/addEditGuardrail/' + 'null' + this.$route.fullPath
				});
			},
			openAutomationPopup() {

				$("ul.dropdown-menu").removeClass("show");
				this.$emit("toggleModal");
				this.callModal = true;
				const vm = this;
				this.$nextTick(() => {
					window.$("#addEditAutomation").modal({
						show: true
					});
				});
			},
			selectOwner(data){
				this.$store.state.currentPageNumber = 1
				this.subTarget = null
				this.subTargetValue = null
				if(data.type === 'Me'){
					this.$store.state.automation.owner = 'Me';
					this.$store.dispatch("automation/getAutomations");
				}
				else{
					this.$store.state.automation.owner = 'All';
					this.$store.dispatch("automation/getAutomations");
				}
			},
			selectTarget(data){
				this.$store.state.automation.target = data
				this.$store.state.currentPageNumber = 1
				this.subTarget = null
				this.subTargetValue = null
				this.$store.dispatch("automation/getAutomations");
			},
			resetTarget(data){
				this.$store.state.automation.target = ''
				this.$store.state.currentPageNumber = 1
				this.subTarget = null
				this.subTargetValue = null
				this.$store.dispatch("automation/getAutomations");
			},
			resetOwner(){
				this.$store.state.currentPageNumber = 1
				this.$store.state.automation.owner = 'All';
				this.subTargetValue = null
				this.subTarget = null
				this.$store.dispatch("automation/getAutomations");
			},
			getTrackBy(){
				
				if(this.subTarget&& this.subTarget.id  == 'Vendor'){
					return 'name'
				}
				else if(this.subTarget&& this.subTarget.id  == 'Profile'){
					return 'ams_profile_id'
				}
				else{
					return 'name'
				}
			}
		}
	};
</script>
